module.exports = __webpack_public_path__ + "static/media/unity_engine_image.65a2b13a.png";